import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';
import { notEmpty } from '../../../../form';

export const MfaSmsCodeFormValidation = object({
  code: notEmpty(string()),
});

export type MfaSmsCodeFields = Infer<typeof MfaSmsCodeFormValidation>;
